import { render, staticRenderFns } from "./sectionTitle.vue?vue&type=template&id=61549f87&scoped=true&"
import script from "./sectionTitle.vue?vue&type=script&lang=js&"
export * from "./sectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./sectionTitle.vue?vue&type=style&index=0&id=61549f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61549f87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61549f87')) {
      api.createRecord('61549f87', component.options)
    } else {
      api.reload('61549f87', component.options)
    }
    module.hot.accept("./sectionTitle.vue?vue&type=template&id=61549f87&scoped=true&", function () {
      api.rerender('61549f87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/dividend/sectionTitle.vue"
export default component.exports